export default {
    meta: {
        title: '机会点列表',
        url: '/standardstore/chancepointlist',
        urlName: '标准版拓店-机会点',
    }
};
